export const REDUCER_NAME = 'account'
export const CUSTOMER_COS = 'customerCos'
export const IS_LOADING_COS = 'isLoadingCos'

export const SET_IS_LOADING_COS = 'SET_IS_LOADING_COS'
export const SET_CUSTOMER_COS = 'SET_CUSTOMER_COS'
